/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasResponse } from '../../openapi/models/OasResponse';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30ResponseDefinition } from '../../openapi/v3/models/Oas30ResponseDefinition';
import { AddResponseDefinitionCommand } from './AddResponseDefinitionCommand';

/**
 * OAI version 3.0.x impl.
 * @author eric.wittmann@gmail.com
 * @extends AddResponseDefinitionCommand
 * @class
 */
export class AddResponseDefinitionCommand_30 extends AddResponseDefinitionCommand {
    public _nullComponents : boolean;

    public constructor(definitionName? : any, from? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((from != null) || from === null)) {
            let __args = arguments;
            super(definitionName, from);
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else if(((typeof definitionName === 'string') || definitionName === null) && from === undefined) {
            let __args = arguments;
            super(definitionName);
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else if(definitionName === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#defExists(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {boolean}
     */
    defExists(document : OasDocument) : boolean {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components)) {
            return false;
        }
        return !this.isNullOrUndefined(doc30.components.getResponseDefinition(this._newDefinitionName));
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#prepareDocumentForDef(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    prepareDocumentForDef(document : OasDocument) {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components)) {
            doc30.components = doc30.createComponents();
            this._nullComponents = true;
        } else {
            this._nullComponents = false;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#createResponseDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {OasResponse}
     */
    createResponseDefinition(document : OasDocument) : OasResponse {
        let doc30 : Oas30Document = <Oas30Document>document;
        let definition : Oas30ResponseDefinition = doc30.components.createResponseDefinition(this._newDefinitionName);
        Library.readNode(this._newDefinitionObj, definition);
        return definition;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#addDefinition(io.apicurio.datamodels.openapi.models.OasDocument, io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasDocument} document
     * @param {OasResponse} definition
     */
    addDefinition(document : OasDocument, definition : OasResponse) {
        let doc30 : Oas30Document = <Oas30Document>document;
        doc30.components.addResponseDefinition(this._newDefinitionName, <Oas30ResponseDefinition>definition);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand#removeDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    removeDefinition(document : OasDocument) {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this._nullComponents) {
            doc30.components = null;
        } else {
            doc30.components.removeResponseDefinition(this._newDefinitionName);
        }
    }
}
AddResponseDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.AddResponseDefinitionCommand_30";
AddResponseDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




